import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';

import {
  getCampaignElementById,
  updateCampaignElementValue,
  getCampaignElements,
} from '@src/redux/modules/campaignLandingPage';
import { LOCATION_BLOCKED_DEFAULT_MESSAGE } from '@src/constants/element-types';
import { COUNTRIES } from '@src/constants/countries';
import styles from '@src/components/CampaignLanding/SubmissionTypeSelectorField.module.less';

const LocationField = ({ _updateCampaignElementValue, element, qid, campaignElements }) => {
  const allowedValues = element?.allowedValues || [];
  const currentValue = campaignElements[qid]?.value || null;
  const selectedCountry = currentValue?.countryCode
    ? COUNTRIES.find((c) => c.code === currentValue.countryCode) || null
    : null;

  const isAllowed = selectedCountry ? allowedValues.includes(selectedCountry.code) : false;
  const showBlockedMessage = !!selectedCountry && !isAllowed;
  const blockMessage = element?.description || LOCATION_BLOCKED_DEFAULT_MESSAGE;

  const handleChange = (_event, country) => {
    if (!country) {
      _updateCampaignElementValue({ qid, value: null, selected: false });
      return;
    }

    // `selected` is only true when the chosen country is allowed, so an out-of-region
    // pick keeps the submission blocked (see getReadyToSubmit).
    _updateCampaignElementValue({
      qid,
      value: { countryCode: country.code, countryName: country.name },
      selected: allowedValues.includes(country.code),
    });
  };

  return (
    <section className={styles.vpSubmissionTypeSelectorContainer}>
      <Box className={styles.vpSelectorSection}>
        <label className={styles.vpLabel}>
          {element?.label || 'Where are you located?'}
          {element?.required && <span className={styles.vpRequiredLabel}>*</span>}
        </label>

        <Box className={styles.vpOptionsContainer}>
          <Autocomplete
            fullWidth
            size="small"
            options={COUNTRIES}
            value={selectedCountry}
            onChange={handleChange}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Select your country" />
            )}
          />
        </Box>

        {showBlockedMessage && (
          <Typography variant="caption" color="error" className={styles.vpErrorMessage}>
            {blockMessage}
          </Typography>
        )}
      </Box>
    </section>
  );
};

LocationField.propTypes = {
  _updateCampaignElementValue: PropTypes.func,
  element: PropTypes.object,
  qid: PropTypes.string,
  campaignElements: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  return {
    element: getCampaignElementById(state, ownProps.qid),
    campaignElements: getCampaignElements(state),
  };
}

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationField);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/LocationField.jsx